document.addEventListener('DOMContentLoaded', function () {
    const blocks = document.querySelectorAll('.wp-block-jims-wp-state-location-index');

    const toggleSection = function (section, shouldOpen) {
        const toggle = section.querySelector('.jims-state-location-index__toggle');
        const panel = section.querySelector('.jims-state-location-index__panel');
        if (!toggle || !panel) {
            return;
        }

        section.classList.toggle('is-open', shouldOpen);
        toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
        panel.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
    };

    blocks.forEach(function (block) {
        // Each rendered block owns its own controls and search state so pages
        // with multiple indexes do not cross-toggle sections.
        const sections = block.querySelectorAll('.jims-state-location-index__section');
        const alphabetButtons = block.querySelectorAll('.jims-state-location-index__alphabet-button');
        const searchInput = block.querySelector('.jims-state-location-index__search-input');

        sections.forEach(function (section) {
            const toggle = section.querySelector('.jims-state-location-index__toggle');
            if (!toggle) {
                return;
            }

            toggle.addEventListener('click', function () {
                const isOpen = section.classList.contains('is-open');
                toggleSection(section, !isOpen);
            });
        });

        alphabetButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                const letter = button.getAttribute('data-letter');
                const target = block.querySelector('.jims-state-location-index__section[data-letter="' + letter + '"]');
                if (!target) {
                    return;
                }

                sections.forEach(function (section) {
                    toggleSection(section, section === target);
                });

                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        });

        if (searchInput) {
            searchInput.addEventListener('input', function () {
                const term = searchInput.value.trim().toLowerCase();

                sections.forEach(function (section) {
                    const suburbItems = section.querySelectorAll('.jims-state-location-index__suburb-item');
                    const visibleItems = [];

                    suburbItems.forEach(function (item) {
                        const searchText = item.getAttribute('data-search-text')
                          || item.getAttribute('data-suburb-name')
                          || '';
                        const isMatch = term === '' || searchText.includes(term);
                        item.hidden = !isMatch;

                        if (isMatch) {
                            visibleItems.push(item);
                        }
                    });

                    const countEl = section.querySelector('.jims-state-location-index__toggle-count');
                    if (countEl) {
                        countEl.textContent = String(visibleItems.length);
                    }

                    if (term === '') {
                        section.hidden = false;
                        toggleSection(section, false);
                    }
                    else {
                        const hasMatch = visibleItems.length > 0;
                        section.hidden = !hasMatch;
                        toggleSection(section, hasMatch);
                    }
                });
            });
        }
    });
});
